import { render, staticRenderFns } from "./BetgameEditUsers.vue?vue&type=template&id=b27de05c&scoped=true"
import script from "./BetgameEditUsers.vue?vue&type=script&lang=js"
export * from "./BetgameEditUsers.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditUsers.vue?vue&type=style&index=0&id=b27de05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27de05c",
  null
  
)

export default component.exports